module.exports = __webpack_public_path__ + "static/media/sidebar1.5f91d8bf.jpg";